import {ErrorMessages} from 'constants/Errors';

import {AxiosResponse} from 'axios';
import {call, put} from 'redux-saga/effects';
import {getBreweryBeers, getSingleBreweryData} from 'services/breweries';
import {handleError} from 'store/app/error/saga';
import ApiData from 'typescript/interfaces/ApiData';
import {Beer} from 'typescript/models/Beer';
import Brewery from 'typescript/models/Brewery';

import {getBreweryBeersACS, getSingleBreweryACS} from '../requestAC';
import {
  setBreweryBeersAC,
  setBreweryBeersIncludedAC,
  setSingleBreweryAC,
  setBreweryBeersPageInfoAC,
} from '../singleBrewerySlice';

export function* getSingleBrewery(action: ReturnType<typeof getSingleBreweryACS>) {
  try {
    const response: AxiosResponse<ApiData<Brewery>> = yield call(getSingleBreweryData, action.payload);

    yield put(setSingleBreweryAC(response.data.data));
  } catch (error) {
    yield call(handleError, error, ErrorMessages.DATA);
  }
}

export function* getBreweryBeersSaga(action: ReturnType<typeof getBreweryBeersACS>) {
  try {
    const response: AxiosResponse<ApiData<Beer[]>> = yield call(getBreweryBeers, action.payload);

    yield put(setBreweryBeersAC(response.data.data));
    yield put(
      setBreweryBeersPageInfoAC({
        totalPages: response.data.meta.total_pages,
        totalCount: response.data.meta.total_count,
      }),
    );
    yield put(setBreweryBeersIncludedAC(response.data.included));
  } catch (error) {
    yield call(handleError, error, ErrorMessages.BREWERY_BEERS);
  }
}
